export default "__VITE_ASSET__DtG220Iy__"